
$('document').ready(function(){
  
  /* DISABLE # LINKS */
  $("a[href='#']").addClass("no-click");
  $("a[href='#']").removeAttr("href");

  /* COMPARE POPUP */


  $(".m-compare-box .m-modal--close").on( "click", function() {
    $(".m-compare-box").stop();
    $(".m-compare-box").hide();
  } );

  $(".m-compare-button").on( "click", function() {
    if($(this).hasClass("added-to-compare")){
      
    }
    else{
      $(".m-compare-box").stop(true, true);
      $(".m-compare-box").show();
      $(".m-compare-box").fadeTo(1, 1).delay(5000).fadeTo(1, 0).delay(1).fadeOut(1);      
    }

  } );

});
